import { render, staticRenderFns } from "./cdeclarelist.vue?vue&type=template&id=8e0f1a72&scoped=true"
import script from "./cdeclarelist.vue?vue&type=script&lang=js"
export * from "./cdeclarelist.vue?vue&type=script&lang=js"
import style0 from "./cdeclarelist.vue?vue&type=style&index=0&id=8e0f1a72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0f1a72",
  null
  
)

export default component.exports